import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';

export const appStatusSliceName = 'appStatus';

const getInitialState = () => ({ appLoaded: true });

export const appStatusSlice = createSlice({
  name: appStatusSliceName,
  initialState: getInitialState(),
  reducers: {
    setAppLoaded(state, { payload }: PayloadAction<boolean>) {
      state.appLoaded = payload;
    },
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export const { setAppLoaded, reset } = appStatusSlice.actions;

export const selectAppLoaded = (state: RootState): boolean => {
  return state[appStatusSliceName].appLoaded;
};
